import { render, staticRenderFns } from "./site-list.vue?vue&type=template&id=80afad72&scoped=true&"
import script from "./site-list.vue?vue&type=script&lang=js&"
export * from "./site-list.vue?vue&type=script&lang=js&"
import style0 from "./site-list.vue?vue&type=style&index=0&id=80afad72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80afad72",
  null
  
)

export default component.exports